var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef, useState } from 'react';
import { authManager } from './authManager';
export const useAuthData = () => {
    const [authData, setAuthData] = useState(null);
    const [expired, setExpired] = useState(true);
    const timeoutRef = useRef(null);
    useEffect(() => {
        const getAuthData = () => __awaiter(void 0, void 0, void 0, function* () {
            const authData = yield authManager.getAuthData();
            setAuthData(authData);
            setExpired(false);
            timeoutRef.current = setTimeout(() => {
                setExpired(true);
            }, authManager.accessTokenExpiresInMs());
        });
        getAuthData();
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [expired]);
    return authData;
};
//# sourceMappingURL=useAuthData.js.map